export default __webpack_public_path__ + "static/media/speed-icon.e3d2ac02.svg";